import { render, staticRenderFns } from "./Gracias.vue?vue&type=template&id=37ad030c&scoped=true&lang=html&"
import script from "./Gracias.vue?vue&type=script&lang=js&"
export * from "./Gracias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad030c",
  null
  
)

export default component.exports